module.exports = __webpack_public_path__ + "static/media/img2-240-240.d97098b8.webp";